import { getFormattedSlug } from '@src/pages/[...slug]/components/collection/utils'

import { ContentfulExperimentConfig } from '../ContentfulExperimentConfig'

import ContentfulImage, { ContentfulImageForMenuItem } from './ContentfulImage'

// @i18n-ignore-start
export const PLATFORM_TYPES = {
  ALL: 'ALL',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  APP: 'APP',
}
// @i18n-ignore-end

type ValuesOf<T> = T[keyof T]

export type PlatformTypes = ValuesOf<typeof PLATFORM_TYPES>
export interface IContentfulLink {
  id: string
  text: string
  subText?: ContentfulSubText | null
  entry?: ContentfulEntry | null
  logo?: ContentfulImage | ContentfulImageForMenuItem
  url?: string | null
  scrollToHash?: string | null
  slug?: string | null
  textColor?: string | null
  experimentConfig?: ContentfulExperimentConfig[]
  applicablePlatforms?: PlatformTypes[] | null
}

interface ContentfulSubText {
  raw: string
}
interface ContentfulEntry {
  name?: string | null
  slug: string
}

export default class ContentfulLink implements IContentfulLink {
  readonly id: string
  readonly text: string
  readonly logo?: ContentfulImage | ContentfulImageForMenuItem
  readonly subText?: ContentfulSubText | null
  readonly entry?: ContentfulEntry | null
  readonly url?: string | null
  readonly slug?: string | null
  readonly scrollToHash?: string | null
  readonly textColor?: string | null
  experimentConfig?: ContentfulExperimentConfig[]
  applicablePlatforms?: PlatformTypes[] | null
  constructor({
    text,
    subText,
    entry,
    url,
    slug,
    id,
    logo,
    textColor,
    experimentConfig,
    applicablePlatforms,
  }: IContentfulLink) {
    this.id = id
    this.text = text
    this.subText = subText
    this.entry = entry
    this.url = url
    this.slug = slug
    this.scrollToHash = slug
    this.textColor = textColor
    this.logo = logo
    this.experimentConfig = experimentConfig
    this.applicablePlatforms = applicablePlatforms
    return {
      ...this,
    }
  }

  static getLinkPath = (link: ContentfulLink | null | undefined) => {
    if (!link) return '/'
    if (link.entry?.slug) return `/${getFormattedSlug(link.entry.slug)}`
    if (link.slug) return `/${getFormattedSlug(link.slug)}`
    if (link.url) return link.url
    return '/'
  }
}
